import { ICreateUser, IUpdateUser } from "../../Interfaces/Apis/User.interface";
import { BaseAPI } from "../Common";

class User extends BaseAPI {
  create(payload: ICreateUser): Promise<any> {
    return this.makeRequest(`create`, "post", payload);
  }
  createContact(payload: ICreateUser): Promise<any> {
    return this.makeRequest(`create-contact`, "post", payload);
  }

  update(userId: string, payload: IUpdateUser): Promise<any> {
    return this.makeRequest(`${userId}`, "patch", payload);
  }
  updateContact(userId: string, payload: IUpdateUser): Promise<any> {
    return this.makeRequest(`update-contact/${userId}`, "patch", payload);
  }

  async import(file: File, attachmentData: any, targetTenantIds?: string[]) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("attachmentData", JSON.stringify(attachmentData));
    if (targetTenantIds) {
      formData.append("targetTenantIds", JSON.stringify(targetTenantIds));
    }

    return await this.makeRequest("create-contact/import", "post", formData, true);
  }


  getAll(): Promise<any> {
    return this.makeRequest(`all`);
  }

  getUser(userId: string): Promise<any> {
    return this.makeRequest(`${userId}`);
  }
}

export const user = new User("user");
